import React from 'react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import DoctorReferralSection from '../doctor/DoctorReferralSection';

/**
 * Doctor self-service view of their own referredByDoctor + referral chain — same
 * DoctorReferralSection used on the admin edit page, in mode="self" (read-only chain,
 * referredByDoctor settable once via a referral code if still empty).
 */
const DoctorReferralModal = ({ isOpen, onClose, doctor }) => {
  return (
    <Modal
      className="create_user_modal"
      title="Moj referral"
      open={isOpen}
      onCancel={onClose}
      footer={null}
    >
      <DoctorReferralSection doctor={doctor} mode="self" />
    </Modal>
  );
};

DoctorReferralModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  doctor: PropTypes.shape({
    _id: PropTypes.string,
    referredByDoctor: PropTypes.string,
  }),
};

export default DoctorReferralModal;
